import { formatDate } from '@angular/common';
import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { ApiservicesService } from '../../../../apiservices.service';
import { UserTopComponent } from '../../../../components/user-top/user-top.component';
import { EncryptdecryptService } from '../../../../services/encryptdecrypt.service';
import { APP_CONFIG, AppConfig } from '../../../../app-config';

@Component({
  providers: [UserTopComponent],
  selector: 'app-butiran-daftar-kemaskini',
  templateUrl: './butiran-daftar-kemaskini.component.html',
  styleUrls: ['./butiran-daftar-kemaskini.component.css']
})
export class ButiranDaftarKemaskiniComponent implements OnInit {
  //UI View Alert Variables
  AlertType: string = "";
  AlertStatus: boolean = false;
  AlertMessage: string = "";

  //UI Status Variables
  LoaderStatus: boolean = false;
  SearchStatus: boolean = false;

  //UI Input Variables
  RoleInput: any = "";
  IDTypeInput: any = "";
  IDNoInput: any = "";
  EmailInput: any = "";

  //UI View Variables
  ViewName: any = "";
  ViewIDNo: any = "";
  ViewItRefNo: any = "";
  ViewIDType: any = "";
  ViewIDTypeString: any = "";
  ViewDateOfBirth: any = "";
  ViewPersonalEmail: any = "";
  ViewUserFirmEmail: any = "";
  ViewUserCertStart: any = "";
  ViewUserCertEnd: any = "";
  ViewRegisterAgentOnly: boolean = false;

  //Session Variables
  SessionFirmID: any = "";
  SessionStaffID: any = "";
  //SessionRegisterAgentOnly: any = "";
  
  // Config property for HTML access
  MyTaxAddress: string = "";



  constructor(
    private apiServices: ApiservicesService, 
    public router: Router, 
    private top: UserTopComponent, 
    private encryptDecryptService: EncryptdecryptService,
    @Inject(APP_CONFIG) private config: AppConfig
  ) { 
    this.MyTaxAddress = config.MyTaxAddress; // Make available to HTML
  }
  ngOnInit(): void {
    this.top.updateTotal();
    this.SessionFirmID = this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || '');
    this.SessionStaffID = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffID') || '');
    this.ViewRegisterAgentOnly = sessionStorage.getItem('Register') !== null ? true : false;
    //this.SessionRegisterAgentOnly = this.encryptDecryptService.decrypt(sessionStorage.getItem('Register') || '');
  }
  async Hantar(IDType:any,IDNo: any) {
    this.LoaderStatus = true;
    this.ResetValue();
    if (IDType === "" || IDNo === "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.SearchStatus = false;
      this.LoaderStatus = false;
    } else if (IDType === "1" && isNaN(IDNo)) {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan MyKad/MyPR/MyKAS yang tepat";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.SearchStatus = false;
      this.LoaderStatus = false;
    } else {
      let Params = {
        "FirmID": Number(this.SessionFirmID),
        "IDType": Number(IDType),
        "IDNo": IDNo
      }
      const result = await this.apiServices.GetDetailTaxPayer(Params);
      if (result.hasError) {
        this.AlertType = "fail";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.SearchStatus = false;
        this.LoaderStatus = false;
      } else {
        this.ViewName = result.name.toUpperCase();
        this.ViewIDNo = result.idNo;
        this.ViewDateOfBirth = result.birthOfDate === "" || result.birthOfDate === null ? "N/A" : formatDate(result.birthOfDate, 'dd-MMM-yyyy', "en-US");
        this.ViewIDType = result.idType;
        this.ViewIDTypeString = result.idTypeString;
        this.ViewItRefNo = result.itGrpCd + " " + result.itRefNo;
        this.ViewPersonalEmail = result.taxPayerEmail === null ? "N/A" : result.taxPayerEmail;
        this.ViewUserFirmEmail = result.userFirmEmail === null ? null : result.userFirmEmail;
        this.ViewUserCertStart = result.certStart === "" || result.certStart === null ? "N/A" : formatDate(result.certStart, 'dd-MMM-yyyy', "en-US");
        this.ViewUserCertEnd = result.certEnd === "" || result.certEnd === null ? "N/A" : formatDate(result.certEnd, 'dd-MMM-yyyy', "en-US");
        this.SearchStatus = true;
        this.LoaderStatus = false;
      }
    }
    
  }
  async StaffRegister(IDType:any,IDNo: any, Role: any, Email: any) {
    this.LoaderStatus = true;
    const expression: RegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (Role === "" || Email === "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila isi butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else if (!expression.test(Email)) {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan emel mengikut format yang betul.";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      let Params = {
        "StaffID": Number(this.SessionStaffID),
        "IDType": Number(IDType),
        "IDNo": IDNo,
        "FirmID": Number(this.SessionFirmID),
        "Role": Role,
        "Email": Email
      }
      const result = await this.apiServices.RegisterStaff(Params);
      if (result.hasError) {
        this.AlertType = "fail";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
      } else {
        this.AlertType = "success";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
          this.LoaderStatus = false;
          if (this.ViewRegisterAgentOnly)
            document.location.href = this.config.MyTaxAddress; // <-- Use config value
          else
            this.redirectTo("/daftar-kemaskini");

        }, 4000);
      }
    }
  }

  Semula(){
    this.RoleInput = "";
    this.IDNoInput = "";

    this.SearchStatus = false;
    this.ViewName = "";
    this.ViewIDNo = "";
    this.ViewItRefNo = "";
    this.ViewIDType = "";
    this.ViewIDTypeString = "";
    this.ViewDateOfBirth = "";
  }
  ResetValue() {
    this.RoleInput = "";
    this.EmailInput = "";

    this.SearchStatus = false;
    this.ViewName = "";
    this.ViewIDNo = "";
    this.ViewItRefNo = "";
    this.ViewIDType = "";
    this.ViewIDTypeString = "";
    this.ViewDateOfBirth = "";
  }
  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri]));
  }
}
